export interface DependencyTableRow {
    dependencyName: string;
    version: string;
    vendorGuidanceStatus: string;
    recommendedVersion?: string;
    riskStatus: string;
}

/** AT_RISK is what the UI calls the LOW_RISK status from the backend */
export const AT_RISK_LABEL = "AT_RISK";

export const NOT_AVAILABLE = "Not Available";

/** "NA" is how dry-run and leadership backend refer to missing version */
export const hasRecommendedVersion = (version?: string): version is string =>
    !!version && version !== "NA";

export const RISK_ORDER = ["HIGH_RISK", "LOW_RISK", "UPGRADE_AVAILABLE", "NO_ACTION_REQUIRED"];

export const riskRank = (status?: string): number => {
    const index = RISK_ORDER.indexOf(status ?? "");
    return index === -1 ? RISK_ORDER.length : index;
};

export const compareByRisk = (
    a: { dependencyName: string; riskStatus: string },
    b: { dependencyName: string; riskStatus: string },
): number =>
    riskRank(a.riskStatus) - riskRank(b.riskStatus) ||
    a.dependencyName.localeCompare(b.dependencyName);

export const filterableText = (row: DependencyTableRow): string =>
    [
        row.dependencyName,
        row.version,
        row.vendorGuidanceStatus,
        hasRecommendedVersion(row.recommendedVersion)
            ? row.recommendedVersion
            : NOT_AVAILABLE,
        row.riskStatus,
        row.riskStatus === "LOW_RISK" ? AT_RISK_LABEL : "",
    ]
        .join(" ")
        .toLowerCase();
